import React, { useState } from 'react'
import { FaPlus } from 'react-icons/fa6';
import Footer from '../components/Footer';

const Contact = () => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    console.log('Form submitted:', formData);
    alert('Thank you for contacting Lenpec Global Concept Limited. Our team will respond shortly.');
  };

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });

  return (
    <section className="contacts-section">
      <div className="contact-container">
        <div className="section-label wow animate__animated animate__fadeInUp" data-wow-delay="1s">
          <FaPlus className="plus-icon" />
          <span>Contact us</span>
        </div>
        
        <div className="contact-form">
          <h2 className="contact-title wow animate__animated animate__fadeInUp" data-wow-delay="1s">Let’s work together.</h2>
          
          <p className="contact-descriptionwow animate__animated animate__fadeInUp" data-wow-delay="1.5s">
            Send us your project details, procurement requirements, or technical specifications.
            Our team is ready to support your oil & gas and industrial projects.
          </p>

          <div className="form-row">
            <input
              type="text"
              name="firstName"
              placeholder="First name*"
              value={formData.firstName}
              onChange={handleInputChange}
              className="form-input wow animate__animated animate__fadeInUp" data-wow-delay="1.5s"
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last name*"
              value={formData.lastName}
              onChange={handleInputChange}
              className="form-input wow animate__animated animate__fadeInUp" data-wow-delay="1.6s"
            />
          </div>
          
          <div className="form-row">
            <input
              type="email"
              name="email"
              placeholder="Email*"
              value={formData.email}
              onChange={handleInputChange}
              className="form-input wow animate__animated animate__fadeInUp" data-wow-delay="1.7s"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone*"
              value={formData.phone}
              onChange={handleInputChange}
              className="form-input wow animate__animated animate__fadeInUp" data-wow-delay="1.8s"
            />
          </div>
          
          <textarea
            name="message"
            placeholder="Project details / specifications*"
            value={formData.message}
            onChange={handleInputChange}
            className="form-textarea wow animate__animated animate__fadeInUp" data-wow-delay="1.9s"
            rows="5"
          />
          
          <button onClick={handleSubmit} className="submit-btn wow animate__animated animate__fadeInUp" data-wow-delay="1.9s">
            Submit
          </button>

          <div className="contact-margin"/>
        </div>
      </div>

      <Footer />
    </section>
  )
}

export default Contact;
